import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../api.ts';
import { ErrorNotice, Loading, Field, TextInput } from '../../components/Bits.tsx';
import { useAdminSession } from './AdminChrome.tsx';

export function AdminSignIn() {
  const { data, isPending } = useAdminSession();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const signIn = useMutation({
    mutationFn: () => api.post('/api/admin/session', { email, password }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['admin'] });
      navigate('/admin');
    },
  });

  if (isPending) return <main className="narrow" id="main"><Loading /></main>;
  if (data?.admin) return <Navigate to="/admin" replace />;

  return (
    <main className="narrow" id="main">
      <h2>Review board sign in</h2>
      <p className="lede">
        Accounts are individual. If you do not have one, ask an administrator to create it.
      </p>

      <ErrorNotice error={signIn.error} />

      <form className="panel" onSubmit={(e) => { e.preventDefault(); signIn.mutate(); }}>
        <Field label="Email address">
          <TextInput type="email" value={email} required autoComplete="email"
                 onChange={(e) => setEmail(e.target.value)} />
        </Field>
        <Field label="Password">
          <TextInput type="password" value={password} required autoComplete="current-password"
                 onChange={(e) => setPassword(e.target.value)} />
        </Field>
        <div className="actions">
          <button type="submit" disabled={signIn.isPending}>
            {signIn.isPending ? 'Signing in…' : 'Sign in'}
          </button>
        </div>
      </form>
    </main>
  );
}
